// extracted by mini-css-extract-plugin
export var divider = "_us-0";